import React, { useEffect, useRef, useState } from 'react';
import { useLang } from '../contexts/LanguageContext';
import { initAffirm, refreshAffirm, affirmEnabled } from '../lib/bnpl';

const PRICES = {
  'refrigerators':  { amount: 1800, parts: [['shop.startingAt', 1800]] },
  'stoves':         { amount: 950,  parts: [['shop.startingAt', 950]] },
  'washers-dryers': { amount: 900,  parts: [['shop.washersFrom', 900], ['shop.towersFrom', 1700]] },
  'microwaves':     { amount: 250,  parts: [['shop.startingAt', 250]] },
};

const AffirmLine = ({ slug, cents }) => {
  const { lang } = useLang();
  const ref = useRef(null);
  const [hasMsg, setHasMsg] = useState(false);

  useEffect(() => {
    if (!affirmEnabled()) return undefined;
    const el = ref.current;
    // Affirm's fallback copy (shown when it has no estimate) mentions checkout; only show real estimates.
    const check = () => { const txt = el.textContent || ''; setHasMsg(/\$\d/.test(txt) && /\/mo\b|\bmes\b/i.test(txt)); };
    const obs = new MutationObserver(check);
    obs.observe(el, { childList: true, subtree: true, characterData: true });
    initAffirm().then(refreshAffirm).catch(() => {});
    return () => obs.disconnect();
  }, [lang]);

  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

  return (
    <div
      className="cat-affirm"
      data-testid={`affirm-als-${slug}`}
      style={hasMsg ? undefined : { display: 'none' }}
      onClick={stop}
    >
      <span
        ref={ref}
        className="affirm-as-low-as"
        data-page-type="category"
        data-amount={cents}
        data-affirm-color="blue"
      />
    </div>
  );
};

export const CategoryPrice = ({ slug }) => {
  const { t } = useLang();
  const p = PRICES[slug];
  if (!p) return null;
  return (
    <>
      <div className="cat-price" data-testid={`cat-price-${slug}`}>
        {p.parts.map(([key, val], i) => (
          <React.Fragment key={key}>
            {i > 0 && ' · '}
            {t(key)} <span>${val.toLocaleString('en-US')}</span>
          </React.Fragment>
        ))}
      </div>
      <AffirmLine slug={slug} cents={p.amount * 100} />
    </>
  );
};

export default CategoryPrice;
